'use strict';

angular.module('mso', ['mso.templates']);
angular.module('mso.templates', []);
angular.module('mso.config', []).constant('SiteConfig', {
    //brand: 'Iress Bank',
    channel: 'Intermediary',
    //sourcePortal: 'MSO'
    operationalFailureMessage:'An error has occurred with the link to an external system or within MSO.<br/>Please contact our customer support helpline on 07777 777777 if the issue persists.',
    operationalFailureWithIdentifierMessage:'An error has occurred with the link to an external system or within MSO.<br/>Please contact our customer support helpline on 07777 777777 quoting $1 if the issue persists.',
    suppressUnexpectedAPIErrors: true,
    suppressUnexpectedErrors: true,
    moduleTransitionMaxAttempts: 10
});
angular.module('mso.interceptors', ['mso.config']);
angular.module('mso.session', []);
angular.module('mso.directives', []);
angular.module('mso.services', ['mso.config']);
angular.module('mso.registration', []);
angular.module('mso.registration.directives', []);
angular.module('authentication.modules', []);
angular.module('mso.authentication', [
  'ngResource',
  'ngRoute',
  'ngAnimate',
  'authentication.modules',
  'mso',
  'mso.templates',
  'mso.config',
  'mso.directives',
  'mso.services',
  'mso.session',
  'toaster',
  'ui.bootstrap'
]);

angular.module('registration.modules', []);
angular.module('mso.registration', [
    'ngResource',
    'ngSanitize',
    'ngRoute',
    'ngAnimate',
    'registration.modules',
    'mso',
    'mso.templates',
    'mso.services',
    'mso.session',
    'mso.directives',
    'mso.registration.directives',
    'toaster',
    'ui.bootstrap',
    'mso.interceptors',
    'pascalprecht.translate'
]);


angular.module('mso', [])
    .config(['$provide', function( $provide )
    {
        $provide.decorator( '$log', ['$delegate', function( $delegate )
        {
            // Save the original $log.debug()
            var debugFn = $delegate.debug;

            $delegate.debug = function( )
            {
                var args    = [].slice.call(arguments),
                    now     = moment().format();

                // Prepend timestamp
                args[0] = "[" + now + "]" + " - " + args[0];

                // Call the original with the output prepended with formatted timestamp
                debugFn.apply(null, args)
            };

            var logFn = $delegate.log;

            $delegate.log = function( )
            {
                var args    = [].slice.call(arguments),
                    now     = moment().format();

                // Prepend timestamp
                args[0] = "[" + now + "]" + " - " + args[0];

                // Call the original with the output prepended with formatted timestamp
                logFn.apply(null, args)
            };

            var infoFn = $delegate.info;

            $delegate.info = function( )
            {
                var args    = [].slice.call(arguments),
                    now     = moment().format();

                // Prepend timestamp
                args[0] = "[" + now + "]" + " - " + args[0];

                // Call the original with the output prepended with formatted timestamp
                infoFn.apply(null, args)
            };

            var warnFn = $delegate.warn;

            $delegate.warn = function( )
            {
                var args    = [].slice.call(arguments),
                    now     = moment().format();

                // Prepend timestamp
                args[0] = "[" + now + "]" + " - " + args[0];

                // Call the original with the output prepended with formatted timestamp
                warnFn.apply(null, args)
            };

            var errFn = $delegate.error;

            $delegate.error = function( )
            {
                var args    = [].slice.call(arguments),
                    now     = moment().format();

                // Prepend timestamp
                args[0] = "[" + now + "]" + " - " + args[0];

                // Call the original with the output prepended with formatted timestamp
                errFn.apply(null, args)
            };





            return $delegate;
        }]);
    }]);

angular.module('mso').constant('CoreConfig', {
    spmApiBaseHref: '/salesprocessmanager/sales-process-manager/v1/api/',
    channel: 'Intermediary'
});
